import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'redux'

import { withModule } from '../redux/goose'
import MessengerAuthModule, { initialise } from '../redux/modules/auth/messenger'

/*
 * This container instructs the Messenger auth module to fetch the context so we can
 * authenticate the user using the Messenger signed request payload.
 */
class MessengerAuthContainer extends React.PureComponent{
  static propTypes = {
    initialise: PropTypes.func
  }

  componentDidMount = () => {
    this.props.initialise()
  }

  render(){
    return null
  }
}

export default compose(
  withModule(MessengerAuthModule),
  connect(null, { initialise : initialise })
)(MessengerAuthContainer)



// WEBPACK FOOTER //
// ./src/Containers/MessengerAuthContainer.js